// 🔧 sponsor_defaults.js
// ✅ Purpose: Generates demo sponsors for the Sponsor Engine
// ✅ Features:
// - Generates sponsors from Sponsor Levels
// - Industry-aware sponsor names
// - Pure template logic (no Firestore)
// - Future-ready for unlimited industries
// - Fully block-commented for clarity and future devs

import { getPowerUpProfile } from "../../../industries/power_up_profiles";

const SPONSOR_MAP_POSITIONS = [
  { x: 30, y: 20 },
  { x: 46, y: 24 },
  { x: 66, y: 20 },
  { x: 82, y: 28 },
];

const slugify = (value = "") =>
  String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

/**
 * Builds sponsor objects for the selected industry.
 */
export const buildSponsorsFromLevels = ({
  industryTemplate,
  sponsorLevels = [],
} = {}) => {
  const sponsorNames = getSponsorNames(industryTemplate);

  const sponsors = [];

  sponsorLevels.forEach((level, levelIndex) => {
    const namesForLevel =
      sponsorNames[levelIndex] || [];

    namesForLevel.forEach((name, sponsorIndex) => {
      const mapPosition =
        SPONSOR_MAP_POSITIONS[sponsors.length % SPONSOR_MAP_POSITIONS.length];

      sponsors.push({
        sponsorId:
          `${level.id}-${sponsorIndex + 1}`,

        levelId: level.id,

        // Keep the demo records compatible with the fields used by the
        // public Sponsor pages. Firestore orderBy() omits documents that do
        // not contain the ordered field, so both the label and stable ID are
        // intentionally stored.
        level: level.name,

        sponsorLevelId: level.id,

        displayOrder:
          (Number(level.displayOrder) || levelIndex + 1) * 100 +
          sponsorIndex,

        sponsorName: name,

        name,

        contactName: `${name} Partnerships Team`,

        contactEmail: `partnerships@${slugify(name)}.example`,

        sponsorContactEmail: `partnerships@${slugify(name)}.example`,

        website: `https://${slugify(name)}.example`,

        url: `https://${slugify(name)}.example`,

        description: `${name} supports this demo experience as the ${level.name}.`,

        logoUrl: "",

        approvalStatus: "approved",

        paymentStatus: "not_required",

        isApproved: true,

        featuredSponsor: levelIndex === 0,

        mapMarkerLabel: `S${sponsors.length + 1}`,

        mapMarkerTitle: name,

        mapMarkerNote: level.name,

        mapMarkerType: "sponsor",

        mapMarkerColor: "success",

        mapMarkerX: mapPosition.x,

        mapMarkerY: mapPosition.y,

        demoSeed: true,
      });
    });
  });

  return sponsors;
};

/**
 * Returns sponsor names based on the industry template.
 */
const getSponsorNames = (
  industryTemplate
) => {
  return getPowerUpProfile(industryTemplate).sponsors.map((name) => [name]);
};
